import { AccountRemoved } from '@/pages/auth/AccountRemoved'
import { ForgotPassword } from '@/pages/auth/Forgot'
import { ResetPassword } from '@/pages/auth/Forgot/reset'
import { SuccessForgotPassword } from '@/pages/auth/Forgot/success'
import { Login } from '@/pages/auth/Login'
import { Signup } from '@/pages/auth/Signup'
import { VerifyEmail } from '@/pages/auth/Signup/VerifyEmail'
import { Cookies } from '@/pages/public/Cookies'
import { Impressum } from '@/pages/public/Impressum'
import { PrivacyPolicy } from '@/pages/public/PrivacyPolicy'
import { TermsConditions } from '@/pages/public/TermsConditions'
import { LandingPage } from '@/pages/public/landing'
import type { RouteObject } from 'react-router-dom'

export const publicRoutes: RouteObject[] = [
  {
    path: '/',
    element: <LandingPage />,
    children: [
      {
        path: 'auth/signup',
        element: <Signup />
      },
      {
        path: 'auth/login',
        element: <Login />
      },
      {
        path: 'auth/account-removed',
        element: <AccountRemoved />
      },
      {
        path: 'auth/validate',
        element: <VerifyEmail />
      },
      {
        path: 'auth/forgot',
        element: <ForgotPassword />
      },
      {
        path: 'auth/forgot/success',
        element: <SuccessForgotPassword />
      },
      {
        path: 'auth/reset-password',
        element: <ResetPassword />
      }
    ]
  },
  {
    path: '/impressum',
    element: <Impressum />
  },
  {
    path: '/gdpr',
    element: <Cookies />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />
  },
  {
    path: '/terms-conditions',
    element: <TermsConditions />
  }
]
